import { BlankIcon, EmptyState, Heading } from '@lmc/ui-kit'
import { Divider } from 'antd'
import { useTranslation } from 'react-i18next'
import type { MonitoringClockedInEntry } from 'screens/Rostering/types'
import styled from 'styled-components'
import EventDetails from './EventDetails'
import TeamMemberAccordion from './TeamMemberAccordion'

type WaitingToClockInWidgetProps = {
  clockedIns: MonitoringClockedInEntry[]
}

const WaitingToClockInWidget = ({
  clockedIns
}: WaitingToClockInWidgetProps) => {
  const { t } = useTranslation()

  if (!clockedIns) return null

  return (
    <Wrapper>
      <Heading level={3}>{t('WAITING_TO_CLOCK_IN')}</Heading>
      <StyledDivider />
      {clockedIns.length === 0 && (
        <EmptyState
          icon={<BlankIcon />}
          title={t('EMPTY_DUE_TO_CLOCK_IN')}
          description={t('EMPTY_DUE_TO_CLOCK_IN_DESC')}
        />
      )}
      {clockedIns.map((clockedIn) => (
        <TeamMemberAccordion
          key={clockedIn.user.id}
          user={clockedIn.user}
          warnings={clockedIn.warnings}
          status={clockedIn.status}
        >
          <Container>
            <StyledDivider />
            <EventDetails event={clockedIn.event} />
          </Container>
        </TeamMemberAccordion>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${(props) => props.theme.color.neutral.color11};
  padding: 24px;
  border-radius: ${(props) => props.theme.properties.borderRadius.large};
  flex: 1;
  height: fit-content;
  min-height: 416px;
`
const StyledDivider = styled(Divider)`
  margin: 0;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px 16px 16px;
`
export default WaitingToClockInWidget
